import { render, staticRenderFns } from "./dispense-popup.vue?vue&type=template&id=52e2204a&scoped=true&"
import script from "./dispense-popup.vue?vue&type=script&lang=js&"
export * from "./dispense-popup.vue?vue&type=script&lang=js&"
import style0 from "./dispense-popup.vue?vue&type=style&index=0&id=52e2204a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2204a",
  null
  
)

export default component.exports